import { useState } from "react";
import { createWatch } from "./StockWatchService";

export default function StockWatchForm({ onSaved }) {
  const [symbol, setSymbol] = useState("");
  const [stockName, setStockName] = useState("");
  const [currentBuyingPrice, setCurrentBuyingPrice] = useState("");
  const [targetBuyPrice, setTargetBuyPrice] = useState("");
  const [targetSellPrice, setTargetSellPrice] = useState("");
  const [remarks, setRemarks] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!symbol) return;
    await createWatch({
      symbol,
      stockName,
      currentBuyingPrice: currentBuyingPrice ? Number(currentBuyingPrice) : null,
      targetBuyPrice: targetBuyPrice ? Number(targetBuyPrice) : null,
      targetSellPrice: targetSellPrice ? Number(targetSellPrice) : null,
      remarks,
    });
    setSymbol("");
    setStockName("");
    setCurrentBuyingPrice("");
    setTargetBuyPrice("");
    setTargetSellPrice("");
    setRemarks("");
    if (onSaved) onSaved();
  };

  return (
    <form className="card stack-form" onSubmit={submit}>
      <h3>Add Watchlist Item</h3>

      <input value={symbol} onChange={(e) => setSymbol(e.target.value)} placeholder="Symbol" required />
      <input value={stockName} onChange={(e) => setStockName(e.target.value)} placeholder="Stock name" />
      <input
        type="number"
        value={currentBuyingPrice}
        onChange={(e) => setCurrentBuyingPrice(e.target.value)}
        placeholder="Current buying price"
      />
      <input
        type="number"
        value={targetBuyPrice}
        onChange={(e) => setTargetBuyPrice(e.target.value)}
        placeholder="Target buying price"
      />
      <input
        type="number"
        value={targetSellPrice}
        onChange={(e) => setTargetSellPrice(e.target.value)}
        placeholder="Target selling price"
      />
      <input value={remarks} onChange={(e) => setRemarks(e.target.value)} placeholder="Remarks" />

      <button className="btn btn-primary" type="submit">
        Save
      </button>
    </form>
  );
}
